declare global {
    interface Date {
        addMonth: (monthCount: number) => Date;
    }
}

Date.prototype.addMonth = function (monthCount: number): Date {
    this.setMonth(this.getMonth() + monthCount);
    return this;
}


export { }; 